import type { CurrencyCode } from "./eligibility-constants";

/**
 * Normalized rate to USD for Apply Now revenue reporting.
 * These rates intentionally preserve the retired eligibility funnel's
 * coarse bucketing behavior.
 */
const NORMALIZED_RATE_TO_USD: Record<CurrencyCode, number> = {
  USD: 1,
  CAD: 2,
  GBP: 1,
  AUD: 2,
  EUR: 1,
  DKK: 7,
  SEK: 10,
};

export function normalizeToUSD(amount: number, currencyCode: CurrencyCode) {
  const normalizedRate = NORMALIZED_RATE_TO_USD[currencyCode];
  if (!amount || !currencyCode || !normalizedRate) {
    return 0;
  }

  return amount / normalizedRate;
}
